import React from 'react';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Link } from "react-router-dom";

export const NewArrivals = () => {
	const responsive = {
		superLargeDesktop: {
			// the naming can be any, depends on you.
			breakpoint: { max: 4000, min: 3000 },
			items: 5
		},
		desktop: {
			breakpoint: { max: 3000, min: 1024 },
			items: 4
		},
		tablet: {
			breakpoint: { max: 1024, min: 464 },
			items: 2
		},
		mobile: {
			breakpoint: { max: 464, min: 0 },
			items: 1
		}
	};
	return (
		<div className="container mx-auto flex-row lg:flex px-4 items-center">
			<div className="new_arrivals w-full lg:w-1/5">
				<h2 className="xl:text-5xl text-3xl text-gray-800">NEW ARRIVALS</h2>
				<h4 className="text-base">Our Hottest Collections</h4>
			</div>
			<div className="slider w-full lg:w-4/5">
				<div className="new_arrivals">
					<Carousel responsive={responsive} infinite={true}>
						<div className="text-center">
							<img src="images/chasma-frame.jpg" alt="Geometric" />
							<h3 className="text-xl font-extrabold text-gray-700 mb-3">Geometric</h3>
							<Link to="/productdetail" className="brounded bg-cyan-500 hover:opacity-75 text-white px-10 py-2 inline-block rounded">Explore</Link>
						</div>
						<div className="text-center">
							<img src="images/round-frame.jpg" alt="Round" />
							<h3 className="text-xl font-extrabold text-gray-700 mb-3">Round</h3>
							<Link to="/productdetail" className="brounded bg-cyan-500 hover:opacity-75 text-white px-10 py-2 inline-block rounded">Explore</Link>
						</div>
						<div className="text-center">
							<img src="images/cateeye-frame.jpg" alt="Cat-Eye" />
							<h3 className="text-xl font-extrabold text-gray-700 mb-3">Cat-Eye</h3>
							<Link to="/productdetail" className="brounded bg-cyan-500 hover:opacity-75 text-white px-10 py-2 inline-block rounded">Explore</Link>
						</div>
						<div className="text-center">
							<img src="images/trans-frame.jpg" alt="Transparent" />
							<h3 className="text-xl font-extrabold text-gray-700 mb-3">Transparent</h3>
							<Link to="/productdetail" className="brounded bg-cyan-500 hover:opacity-75 text-white px-10 py-2 inline-block rounded">Explore</Link>
						</div>
						<div className="text-center">
							<img src="images/pid-frame.jpg" alt="Geometric" />
							<h3 className="text-xl font-extrabold text-gray-700 mb-3">Geometric</h3>
							<Link to="/productdetail" className="brounded bg-cyan-500 hover:opacity-75 text-white px-10 py-2 inline-block rounded">Explore</Link>
						</div>
						<div className="text-center">
							<img src="images/cateeye-frame.jpg" alt="Cat-Eye" />
							<h3 className="text-xl font-extrabold text-gray-700 mb-3">Cat-Eye</h3>
							<Link to="/productdetail" className="brounded bg-cyan-500 hover:opacity-75 text-white px-10 py-2 inline-block rounded">Explore</Link>
						</div>
					</Carousel>
				</div>
			</div>
		</div>
	)
}